import React, { forwardRef, useContext } from 'react';

import type { ItemProps } from '../../../../../../../../Menu/components/Item/Item';
import { Item as MenuItem } from '../../../../../../../../Menu/components/Item/Item';
import { SidebarModalContext } from '../../../../../../SidebarModalContext';

export const Item = Object.assign(
  forwardRef<HTMLDivElement, ItemProps>(({ onClick, ...props }, ref) => {
    const { setIsMenuVisible } = useContext(SidebarModalContext);

    const handleClick = () => {
      onClick?.();

      setIsMenuVisible(false);
    };

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <MenuItem ref={ref} onClick={handleClick} {...props} />;
  }),
  {
    LeftComponent: MenuItem.LeftComponent,
    PremiumLabel: MenuItem.PremiumLabel,
    RightComponent: MenuItem.RightComponent,
  },
);
